<template>
  <section class="kmutt-cover" :style="{ backgroundImage: `url(/${this.$staticPath}/images/Home/cover.jpg)` }">
    <div class="overlay" :style="{'background-color': bgOverlay}"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-md-offset-0 text-center animated fadeIn">
          <div class="display-t w-100">
            <div class="display-tc px-4 w-100">
              <template v-if="showLandingText">
                <img :src="`/${this.$staticPath}/images/logo.png`" alt="logo" width="90">
                <h1 class="word-cover text-white mt-3">Engineering Science Classroom</h1>
              </template>
              <template v-else>
                <div class="quote text-white">
                  <h1 class="text-left mb-3 text-top">" {{selectedText.firstQuote.text}}</h1>
                  <h1 class="text-center mb-3 text-middle" :class="{keyWord: selectedText.secondQuote.isKey}">{{selectedText.secondQuote.text}}</h1>
                  <h1 class="text-right mb-3 text-bottom" :class="{keyWord: selectedText.thirdQuote.isKey}">{{selectedText.thirdQuote.text}} "</h1>
                </div>
                <div class="owner text-white text-right">
                  <p class="mb-1">{{selectedText.quoter}}</p>
                  <p>{{selectedText.position}}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { throttle } from 'throttle-debounce'

export default {
  data () {
    return {
      bgOverlay: 'rgba(4, 8, 19, 0.925)',
      innerText: [
        {
          firstQuote: {
            text: 'เพราะชีวิตจริง',
            isKey: false
          },
          secondQuote: {
            text: 'ปัญหา',
            isKey: true
          },
          thirdQuote: {
            text: ' ไม่เคยแยกเป็นรายวิชา',
            isKey: false
          },
          quoter: 'รศ.ดร.วิวัฒน์ เรืองเลิศปัญญากุล',
          position: 'ที่ปรึกษาโครงการวมว.ห้องเรียนวิศว์-วิทย์'
        },
        {
          firstQuote: {
            text: 'ห้องเรียนวิศว์-วิทย์ ไม่ได้สอนให้เป็นวิศวะ',
            isKey: false
          },
          secondQuote: {
            text: 'แต่จงสอนให้คิดและจงทำซะ',
            isKey: false
          },
          thirdQuote: {
            text: 'Let\'s get it',
            isKey: true
          },
          quoter: 'นางสาวณัฐชญา ชาชุมวงศ์',
          position: 'ประธานกิจกรรมรับน้องและผู้นำสัมทนาการ'
        },
        {
          firstQuote: {
            text: 'คนทุกคนย่อมมีความแตกต่าง',
            isKey: false
          },
          secondQuote: {
            text: 'สิ่งหนึ่งที่ขาดไม่ได้ในการร่วมอยู่กัน คือ',
            isKey: false
          },
          thirdQuote: {
            text: 'ความเข้าใจ',
            isKey: true
          },
          quoter: 'นางสาววาสิตา นิมิตรวงศ์สกุล',
          position: 'นักเรียนแลกเปลี่ยนโครงการ OEG Tennessee, USA ปี 2560'
        }
      ],
      showLandingText: true,
      selectedText: {}
    }
  },
  mounted () {
    window.addEventListener('scroll', throttle(100, this.onMoving), true)
  },
  destroyed () {
    window.removeEventListener('scroll', throttle(100, this.onMoving), true)
  },
  methods: {
    onMoving: function () {
      var distance = this.getDistance()
      var state = this.getState(distance)
      this.setOverlay(state)
      this.setText(state)
    },
    getDistance: function () {
      return window.scrollY
    },
    getState: function (distance) {
      if (distance < 1.25 * window.innerHeight) {
        return 0
      } else if (distance < 3.25 * window.innerHeight) {
        return 1
      } else if (distance < 5.25 * window.innerHeight) {
        return 2
      } else {
        return 3
      }
    },
    setOverlay: function (state) {
      switch (state) {
        case 0:
          this.bgOverlay = 'rgba(4, 8, 19, 0.925)'
          break
        case 1:
          this.bgOverlay = 'rgba(4, 8, 19, 0.75)'
          break
        case 2:
          this.bgOverlay = 'rgba(4, 8, 19, 0.5)'
          break
        case 3:
          this.bgOverlay = 'rgba(4, 8, 19, 0.35)'
          break
      }
    },
    setText: function (state) {
      if (state === 0) {
        this.showLandingText = true
      } else {
        this.showLandingText = false
        this.selectedText = this.innerText[state - 1]
      }
    }
  }
}
</script>

<style scoped>
  @import url('../../../static/css/home-style/cover.css');
</style>



// WEBPACK FOOTER //
// src/components/HOME/Cover.vue